export class ArrayUtil {
    public static intersection<T, K extends keyof T>(arrayA: T[], arrayB: T[], property?: K): T[] {
        if (property) {
            const set2 = new Set(arrayB.map((item) => item[property]));
            return arrayA.filter((item) => set2.has(item[property]));
        } else {
            const a = new Set(arrayA);
            const b = new Set(arrayB);
            return Array.from(a).filter((item) => b.has(item));
        }
    }

    public static isArrayWithLength(array: any[] | undefined): boolean {
        return Array.isArray(array) && array.length > 0;
    }
}
